import api2 from './api-v2';

const get = async (filter) => {
    const client = await api2.getClient();
    const response = await client.get('deployments', { params: filter });
    return api2.handleSuccess(response);
};

const getById = async ({ id }) => {
    const client = await api2.getClient();
    const app = await client.get(`deployments/${id}`);
    return api2.handleSuccess(app);
};

const create = async ({ payload }) => {
    const client = await api2.getClient();
    const response = await client.post('deployments', payload);
    return api2.handleSuccess(response);
};

const remove = async (id) => {
    const client = await api2.getClient();
    const response = await client.delete(`deployments/${id}`);
    return api2.handleSuccess(response);
};

const deploy = async (id) => {
    const client = await api2.getClient();
    const response = await client.post(`deployments/${id}/deploy`);
    return api2.handleSuccess(response);
};


export default {
    get,
    create,
    remove,
    getById,
    deploy
};
